export default {
  login: '登录',
  adminName: '管理员账号',
  telephoneNum: '手机号码',
  valiateCode: '验证码',
  needPassword: '请输入密码',
  bbs: '技术支持',
  help: '帮助',
  online: '在线客服',
  hotline: '技术服务热线：4008 111 000',
  rj: '锐捷网络',
  wechat: '微信公众号',
  feitian: '飞天在线训练平台'
}
